var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIlM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.126,
    height: 71.125,
    viewBox: "0 0 71.126 71.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cogwheel_16503737",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M8.885,39.907l3.47.386a26.279,26.279,0,0,0,1.629,4.165,6.617,6.617,0,0,1,2.916.721,24.132,24.132,0,0,1-2.782-6.927L9.131,37.7a2.145,2.145,0,0,1-1.908-2.132V30a2.145,2.145,0,0,1,1.908-2.132l4.987-.554a24.142,24.142,0,0,1,3.066-7.4L14.049,16a2.145,2.145,0,0,1,.158-2.856l3.935-3.935A2.145,2.145,0,0,1,21,9.048l3.918,3.135a24.141,24.141,0,0,1,7.4-3.066l.554-4.987A2.145,2.145,0,0,1,35,2.223h5.564A2.145,2.145,0,0,1,42.7,4.13l.554,4.987a24.144,24.144,0,0,1,7.4,3.066l3.918-3.135a2.145,2.145,0,0,1,2.856.158l3.935,3.935A2.145,2.145,0,0,1,61.52,16l-3.135,3.918a24.143,24.143,0,0,1,3.066,7.4l4.987.554A2.145,2.145,0,0,1,68.346,30v5.564A2.145,2.145,0,0,1,66.438,37.7l-4.987.554a24.132,24.132,0,0,1-2.782,6.927,6.617,6.617,0,0,1,2.916-.721,26.278,26.278,0,0,0,1.629-4.165l3.47-.386a4.363,4.363,0,0,0,3.885-4.341V30a4.363,4.363,0,0,0-3.885-4.341l-3.47-.386a26.287,26.287,0,0,0-2.139-5.163l2.181-2.727a4.363,4.363,0,0,0-.322-5.816L59,7.635a4.367,4.367,0,0,0-5.816-.322L50.456,9.494a26.289,26.289,0,0,0-5.163-2.139l-.386-3.47A4.363,4.363,0,0,0,40.567,0H35a4.363,4.363,0,0,0-4.341,3.885l-.386,3.47a26.286,26.286,0,0,0-5.163,2.139L22.386,7.313a4.367,4.367,0,0,0-5.816.322L12.635,11.57a4.363,4.363,0,0,0-.322,5.816l2.181,2.727a26.287,26.287,0,0,0-2.139,5.163l-3.47.386A4.363,4.363,0,0,0,5,30v5.564a4.363,4.363,0,0,0,3.885,4.341Z",
    transform: "translate(-2.222)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M47,67.179H65.893V63.852a6.976,6.976,0,0,0-.142-1.529A1.75,1.75,0,0,0,65,61.37l-4.676-2.721-2.946,4.17a1.111,1.111,0,0,1-.908.47h-.066a1.112,1.112,0,0,1-.908-.471L52.563,58.65l-4.637,2.7a1.761,1.761,0,0,0-.783.975A6.95,6.95,0,0,0,47,63.834Z",
    transform: "translate(-20.884 -26.06)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M23.123,109.7a3.926,3.926,0,0,0-1.816-2.335l-5.517-3.211a1.111,1.111,0,0,0-1.466.319l-2.657,3.762-2.651-3.761a1.111,1.111,0,0,0-1.467-.32l-5.479,3.19A3.942,3.942,0,0,0,.215,109.7,9.015,9.015,0,0,0,0,111.786v3.327a2.225,2.225,0,0,0,2.223,2.223H21.115a2.225,2.225,0,0,0,2.223-2.223v-3.307a9.049,9.049,0,0,0-.214-2.109Zm-20.9,5.416v-3.345a6.943,6.943,0,0,1,.142-1.51,1.762,1.762,0,0,1,.783-.975l4.637-2.7,2.938,4.169a1.112,1.112,0,0,0,.908.471H11.7a1.111,1.111,0,0,0,.908-.47l2.946-4.17,4.676,2.721a1.752,1.752,0,0,1,.745.954,6.983,6.983,0,0,1,.142,1.528v3.327Z",
    transform: "translate(0 -46.21)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M13,88.445v2.223a4.445,4.445,0,1,0,8.891,0V88.445a4.445,4.445,0,1,0-8.891,0Z",
    transform: "translate(-5.777 -37.324)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M109.123,109.7a3.926,3.926,0,0,0-1.816-2.335l-5.517-3.211a1.111,1.111,0,0,0-1.466.319l-2.657,3.762-2.651-3.761a1.111,1.111,0,0,0-1.467-.32l-5.479,3.19a3.942,3.942,0,0,0-1.854,2.356A9.014,9.014,0,0,0,86,111.786v3.327a2.225,2.225,0,0,0,2.223,2.223h18.892a2.225,2.225,0,0,0,2.223-2.223v-3.307A9.05,9.05,0,0,0,109.123,109.7Zm-20.9,5.416v-3.345a6.942,6.942,0,0,1,.142-1.51,1.762,1.762,0,0,1,.783-.975l4.637-2.7,2.938,4.169a1.112,1.112,0,0,0,.908.471H97.7a1.111,1.111,0,0,0,.908-.47l2.946-4.17,4.676,2.721a1.752,1.752,0,0,1,.745.954,6.983,6.983,0,0,1,.142,1.528v3.327Z",
    transform: "translate(-38.213 -46.21)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M103.446,95.113a4.45,4.45,0,0,0,4.445-4.445V88.445a4.445,4.445,0,0,0-8.891,0v2.223a4.45,4.45,0,0,0,4.445,4.445Z",
    transform: "translate(-43.989 -37.324)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M58,94.157V89.111a1.111,1.111,0,0,0-2.223,0v5.045l-7.391,6.335a1.111,1.111,0,0,0,1.447,1.688l7.056-6.048,7.056,6.048a1.111,1.111,0,0,0,1.447-1.688Z",
    transform: "translate(-21.328 -39.101)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M43.781,62.964V59.34a3.334,3.334,0,1,1,6.668,0v3.624a21.115,21.115,0,1,0-6.668,0Zm-1.111-30.3a4.445,4.445,0,0,1,8.891,0v2.223a4.445,4.445,0,1,1-8.891,0ZM35.66,45.033a3.943,3.943,0,0,1,1.854-2.356l5.479-3.19a1.111,1.111,0,0,1,1.467.32l2.651,3.761,2.657-3.761a1.111,1.111,0,0,1,1.466-.319L56.753,42.7a3.926,3.926,0,0,1,1.816,2.335,9.052,9.052,0,0,1,.214,2.109V50.45a2.225,2.225,0,0,1-2.223,2.223H37.669a2.225,2.225,0,0,1-2.223-2.223V47.123A9.024,9.024,0,0,1,35.66,45.033Z",
    transform: "translate(-11.552 -9.33)",
    fill: "#7b7bff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlM);
export default __webpack_public_path__ + "static/media/IL_M.c57d2db001c7fb317b72faa8ac5d25f0.svg";
export { ForwardRef as ReactComponent };